import { faFilter, faSearch, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Button, Input, InputGroup, PopoverBody, PopoverHeader } from 'reactstrap';
import { useAuth0 } from '../../../../../../auth0/reactAuth0Spa';
import { checkLoginForError, formatBearerToken } from '../../../../../../Common.functions';
import { fetchDataAuth0 } from '../../../../../../Services/dataApi';
import { clone } from '../../../../../../Services/schedule';
import style from './AdminSentItems.style';
import SentItem from './SentItem/SentItem';
import PopoverCompat from '../../../../Common/PopoverCompat';
import './AdminSentItems.style.css';

const AdminSentItems = ({
  candidates = [],
  interviewDates,
  activeDepartment,
  selectedSentItem,
  setSelectedSentItem,
  sentMessages,
  isFetchingItems,
  forcedFilterCandidate,
  showFilter = true,
  columnSentItems,
  onClick,
  isDark,
}) => {
  const [filterBy, setFilterBy] = useState();
  const [searchString, setSearchString] = useState('');
  const [filteredSentItems, setFilteredSentItems] = useState([]);
  const [availableTemplates, setAvailableTemplates] = useState([]);

  const [showFilterPopover, setShowFilterPopover] = useState(false);
  const { getTokenSilently, loginWithRedirect } = useAuth0();

  useEffect(() => {
    getTemplates();
  }, [activeDepartment]);

  useEffect(() => {
    if (sentMessages) {
      setFilteredSentItems(sentMessages);
      if (sentMessages.length > 0) {
        setSelectedSentItem(sentMessages[0]);
      }
    }
  }, [sentMessages]);

  useEffect(() => {
    if (forcedFilterCandidate) {
      filterByString();
    }
  }, [forcedFilterCandidate]);

  // useEffect(() => {
  //   if (dContext && dContext.department) {
  //     getTemplates();
  //   }
  // }, [dContext]);

  useEffect(() => {
    filterByButton();
  }, [JSON.stringify(filterBy)]);

  useEffect(() => {
    filterByString();
  }, [searchString]);

  useEffect(() => {
    if (forcedFilterCandidate) {
      const newSentMessages = clone(sentMessages);
      const newFilteredSentMessages = [];
      const name = `${forcedFilterCandidate.FirstName || ''} ${forcedFilterCandidate.MiddleName || ''} ${
        forcedFilterCandidate.LastName
      }`;
      newSentMessages.forEach((sm) => {
        const { FirstName, LastName } = sm;
        const msgName = `${FirstName || ''} ${forcedFilterCandidate.MiddleName || ''} ${LastName || ''}`;
        if (name === msgName) {
          newFilteredSentMessages.push(sm);
        }
      });
      setFilteredSentItems(newFilteredSentMessages);
    }
  }, [forcedFilterCandidate]);

  const filterByString = () => {
    // Email,
    // Candidate Name,
    // Sent Date,
    // Template Name,
    // Email Body

    // NOTE: Currently missing Email Body, Mike says disregard Sent Date

    const newFilteredSentMessages = [];
    const name = `${(forcedFilterCandidate && forcedFilterCandidate.FirstName) || ''} ${(forcedFilterCandidate &&
      forcedFilterCandidate.MiddleName) ||
      ''} ${(forcedFilterCandidate && forcedFilterCandidate.LastName) || ''}`.toLowerCase();

    sentMessages.forEach((sm) => {
      const { FirstName = '', MiddleName = '', LastName = '', EmailSentTo = '', Subject = '' } = sm;
      const sentName = `${FirstName || ''} ${MiddleName || ''} ${LastName || ''}`.toLowerCase();
      const matchingTemplate = sm.fk_Template
        ? availableTemplates.find((t) => {
            return t.pk_CommunicationTemplate === sm.fk_Template;
          })
        : null;
      const matchingWithTemplate = matchingTemplate
        ? matchingTemplate.Title.toLowerCase().indexOf(searchString) >= 0
        : null;

      if (
        ((sentName && sentName.indexOf(searchString)) >= 0 ||
          (EmailSentTo && EmailSentTo.toLowerCase().indexOf(searchString) >= 0) ||
          (Subject && Subject.toLowerCase().indexOf(searchString) >= 0) ||
          matchingWithTemplate ||
          !searchString) &&
        ((forcedFilterCandidate && sentName && sentName.indexOf(name) >= 0) || !forcedFilterCandidate)
      ) {
        newFilteredSentMessages.push(sm);
      }
    });

    setFilteredSentItems(newFilteredSentMessages);
    setFilterBy(null);
  };

  const getTemplates = () => {
    if (!activeDepartment) {
      return;
    }
    getTokenSilently()
      .then((token) => {
        fetchDataAuth0(
          'department/readCommunicationTemplates',
          { pk_Department: activeDepartment.pk_Department },
          formatBearerToken(token),
        )
          .then((result) => {
            setAvailableTemplates(result.data);
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const filterByButton = () => {
    const newSentItems = sentMessages.slice().filter((sentItem) => {
      return (
        filterBy === null ||
        filterBy === undefined ||
        (sentItem && filterBy && sentItem.fk_Template === filterBy.pk_CommunicationTemplate)
      );
    });

    setFilteredSentItems(newSentItems);
  };

  const renderFilterButton = () => {
    return (
      <>
        <Button id="filter_button" style={style.filterButton} className="sent-items-filter-button" color="light">
          <div style={style.spacedBetweenRow}>
            <div>{filterBy ? `Messages of type "${filterBy.Title}"` : 'Showing all messages'}</div>
            <div>
              <FontAwesomeIcon icon={faFilter} />
            </div>
          </div>
        </Button>
        <PopoverCompat
          fade={false}
          className="sent-items-filter-popover"
          flip={false}
          placement="bottom"
          placementPrefix="templatesFilter bs-popover"
          isOpen={showFilterPopover}
          trigger="legacy"
          target="filter_button"
          toggle={() => {
            setShowFilterPopover(!showFilterPopover);
          }}
        >
          <PopoverHeader>
            <div style={style.spacedBetweenRow}>
              <div>Templates</div>
              <div>
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  style={style.clickable}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowFilterPopover(false);
                  }}
                />
              </div>
            </div>
          </PopoverHeader>
          <PopoverBody>
            <div style={{ overflowY: 'scroll', height: 350 }}>
              {availableTemplates ? (
                availableTemplates.map((template, i) => {
                  const isSelectedTemplate =
                    filterBy && template.pk_CommunicationTemplate === filterBy.pk_CommunicationTemplate;
                  return (
                    <div
                      key={`template-filter-${template.pk_CommunicationTemplate || i}`}
                      className={`sent-items-template-option${isSelectedTemplate ? ' is-selected' : ''}`}
                      onClick={() => {
                        setFilterBy(template);
                        setShowFilterPopover(false);
                      }}
                    >
                      {template.Title}
                    </div>
                  );
                })
              ) : (
                <div>No Templates</div>
              )}
            </div>
          </PopoverBody>
        </PopoverCompat>
      </>
    );
  };

  const renderSearchInput = () => {
    return (
      <InputGroup className="sent-items-search-group">
        <Button
          className="sent-items-search-clear"
          color="secondary"
          onClick={() => {
            setSearchString('');
            setFilterBy(null);
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </Button>
        <Input
          bsSize="sm"
          className="sent-items-search-input"
          value={searchString}
          type="text"
          placeholder="Search Sent Items. . ."
          onChange={(e) => {
            setFilterBy(null);
            setSearchString(e.target.value.toLowerCase());
          }}
        />
        <Button color="success" className="sent-items-search-submit">
          <FontAwesomeIcon icon={faSearch} />
        </Button>
      </InputGroup>
    );
  };

  return (
    <div className={`sent-items-shell${isDark ? ' is-dark' : ''}`}>
      <div style={{ ...style.simpleRow }} className="sent-items-toolbar">
        {renderSearchInput()}
      </div>
      <div style={style.simpleRow} className="sent-items-filter-row">
        {showFilter ? renderFilterButton() : null}
      </div>
      <div style={{ ...style.simpleRow }} className="sent-items-list-scroll">
        <div id="list_column" style={{ ...style.simpleColumn, width: '100%' }} className="sent-items-list-column">
          {isFetchingItems ? (
            <div className="sent-items-status">Loading Messages. . .</div>
          ) : filteredSentItems && filteredSentItems.length > 0 ? (
            filteredSentItems.map((sentItem, i) => {
              return (
                <SentItem
                  key={`sent-item-${sentItem.pk_CommunicationHistory || i}`}
                  isDark={isDark}
                  columnSentItems={columnSentItems}
                  sentItem={{ ...sentItem, index: i }}
                  setSelectedSentItem={setSelectedSentItem}
                  selectedSentItem={selectedSentItem}
                  onClick={onClick}
                />
              );
            })
          ) : (
            <div className="sent-items-status">No Messages</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminSentItems;
